export class PnFileUploadError<T> extends Error {
  public element: HTMLElement;
  public code: string;
  public data: T;

  constructor(message: string, element: HTMLElement, code: string = 'INVALID', data: T = null) {
    super(message);
    this.name = 'PNFileUploadError';
    this.element = element;
    this.code = code;
    this.data = data;
  }
}
